import { render, staticRenderFns } from "./gridStoricoDettaglioJSON.vue?vue&type=template&id=2aadd888&"
import script from "./gridStoricoDettaglioJSON.vue.ts?vue&type=script&lang=ts&"
export * from "./gridStoricoDettaglioJSON.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports